export enum FilterType {
  Text = "TEXT",
  Boolean = "BOOLEAN",
  Number = "NUMBER",
  Radio = "RADIO",
  AutoComplete = "AUTOCOMPLETE",
  Empty = "EMPTY",
}
